/**
 * GDSScrollLockManager.js
 * A robust, reusable utility to prevent page scrolling when modals are active.
 * Handles scrollbar-width compensation to prevent content jumps and includes iOS fixes.
 */
export const GDSScrollLockManager = {
    lockCount: 0,
    originalScrollY: 0,

    /**
     * Disables scrolling on the document body.
     */
    lock() {
        if (this.lockCount === 0) {
            this.originalScrollY = window.scrollY;

            // 1. Calculate scrollbar width and add padding to prevent content jump
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.paddingRight = `${scrollbarWidth}px`;

            // 2. Add a class for base styling
            document.body.classList.add('scroll-locked');

            // 3. Apply inline styles for robust locking, including the iOS fix
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.originalScrollY}px`;
            document.body.style.width = '100%';
        }
        this.lockCount++;
    },

    /**
     * Re-enables scrolling on the document body.
     */
    unlock() {
        this.lockCount--;
        if (this.lockCount === 0) {
            // 1. Remove the class
            document.body.classList.remove('scroll-locked');

            // 2. Remove all inline styles to restore original state
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.paddingRight = '';

            // 3. Restore the original scroll position
            window.scrollTo(0, this.originalScrollY);
        }
    }
};
